__turbopack_context__.v({
  "card": "a2kKHW_card",
  "gridContainer": "a2kKHW_gridContainer",
  "paper": "a2kKHW_paper",
});
